import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  apiUrl2 = `${environment.API_URL2}/error` ;
  constructor(private http : HttpClient) { }

  getAllErrorLog(){
    return this.http.get(`${this.apiUrl2}/getAllErrorLog`);
  }
  errorLog(params){
    return this.http.post(`${this.apiUrl2}/errorLog`,params);
  }
  


  // getusertransactionsummary(user_id){
  //   return this.http.post(`${this.apiUrl2}/getusertransactionsummary/`,user_id);
  // }
  

  
}
